import {
  Button,
  Modal,
  Spinner,
  IconButton,
  IconTile,
  InputText,
  InputTextarea,
  Label,
  Switch,
} from '@teo/components';
import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGet } from '@/query/fetchHooks';
import { format } from 'date-fns';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { axios } from '@/axios';
import { config } from '@/config';
import { newUid, nthIndexOf } from '@/util';
import { useNavigate } from 'react-router-dom';
import {
  CrossFilled,
  Training,
  Evaluation,
  Flag,
  Plus,
  PencilFilled,
  TrashIcon,
  City,
} from '@teo/components/icons';
import PracticalInformationTR from './PracticalInformationTr';
import SettingsTR from './SettingsTR';
import SettingsTRM from './SettingsTRM';

export const ModalSettingsTraining = ({
  authOrg,
  authUser,
  learningpath,
  setIsOpenSettings,
  setSelectTrainig,
  selectTrainig,
  setResetContent,
}) => {
  const { t } = useTranslation();
  const [trainingName, setTrainingName] = useState('');
  const [trainingDescription, setTrainingDescription] = useState('');
  const [training, setTraining] = useState(null);
  const [location, setLocation] = useState(null);
  const [registrationLink, setRegistrationLink] = useState(null);
  const [typeOfTraining, setTypeOfTraining] = useState(null);
  const [trainingContentLinking, setTrainingContentLinking] = useState(null);
  const [changeTraining, setChangeTraining] = useState({});
  const [customSettings, setCustomSettings] = useState(false);
  const [minScore, setMinScore] = useState(0);

  const [milestoneChange, setMilestoneChange] = useState({});

  useGet(`/training/${selectTrainig?.objectId}`, {
    retry: false,
    enabled: !!selectTrainig?.objectId,
    onSuccess: (result) => {
      setTraining(result?.data || {});
      setLocation(result?.data?.location || null);
      setRegistrationLink(result?.data?.url || null);
      setTrainingName(result?.data?.trainingName || '');
      setTrainingDescription(result?.data?.trainingDescription || '');
      setTypeOfTraining(result?.data?.typeOfTraining || 'external');
      setTrainingContentLinking(result?.data?.contentLinkingType || 'URL');
      setCustomSettings(result?.data?.hasCustomSettings || false);
      setMinScore(result?.data?.minScore);
    },
  });

  useEffect(() => {
    setTimeout(() => {
      document.body.style.overflow = 'hidden';
    }, 0);
  }, []);

  function areArraysEqual(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (a.length !== b.length) return false;
    return a.every((val, index) => val === b[index]);
  }

  const handleChangeTraining = async () => {
    if (training) {
      const changes = {};

      if (customSettings !== training?.hasCustomSettings) {
        changes.hasCustomSettings = customSettings;
      }
      if (trainingName !== training?.trainingName) {
        changes.trainingName = trainingName;
      }
      if (trainingDescription !== training?.trainingDescription) {
        changes.trainingDescription = trainingDescription;
      }
      if (minScore !== training?.minScore) {
        changes.minScore = minScore;
      }
      if (location !== training?.location) {
        changes.location = location ? location : null;
      }
      if (registrationLink !== training?.url) {
        changes.url = registrationLink ? registrationLink : null;
      }
      if (typeOfTraining !== training?.typeOfTraining) {
        changes.typeOfTraining = typeOfTraining;
      }
      if (trainingContentLinking !== training?.contentLinkingType) {
        changes.contentLinkingType = trainingContentLinking;
      }
      if (changeTraining?.institutionId !== training?.institutionId) {
        changes.institutionId = changeTraining?.institutionId;
      }
      if (
        milestoneChange?.motivationalMessage !==
          training?.motivationalMessage &&
        milestoneChange?.motivationalMessage
      ) {
        changes.motivationalMessage = milestoneChange?.motivationalMessage;
      }
      if (milestoneChange?.titleCertificate !== training?.titleCertificate) {
        changes.titleCertificate = milestoneChange?.titleCertificate;
      }

      if (
        !areArraysEqual(
          milestoneChange?.modulesCertificate,
          training?.modulesCertificate
        )
      ) {
        changes.modulesCertificate = milestoneChange?.modulesCertificate;
      }

      if (
        !areArraysEqual(
          changeTraining?.contactPersonIds,
          training?.contactPersonIds
        )
      ) {
        changes.contactPersonIds = changeTraining?.contactPersonIds;
      }

      await axios.put(`${config.backend}/training/${training?.id}`, changes);
      setResetContent(newUid(20));
      document.body.style.overflow = 'unset';
      setSelectTrainig(null);
      setIsOpenSettings(false);
    }
  };

  // console.log(changeTraining);

  return (
    <div className="fixed top-0 left-0 z-[100] h-screen w-screen overflow-y-auto bg-white">
      <div className="flex min-h-20 flex-col justify-start py-2 pr-2 sm:flex-row sm:items-center">
        <div
          data-testid="clouseBtn"
          className="flex min-h-20 items-center justify-start"
        >
          <IconButton
            className="my-auto mx-3 sm:mx-6"
            Icon={CrossFilled}
            variant="ghost"
            onClick={() => {
              document.body.style.overflow = 'unset';
              setSelectTrainig(null);
              setIsOpenSettings(false);
            }}
          />
          <div className="flex items-center">
            <div
              className={`min-[72px] mr-5 flex h-12 w-[72px] justify-center rounded-[4px] ${
                training?.trainingType === 'training'
                  ? 'bg-tint-green-light'
                  : training?.trainingType === 'milestone'
                  ? 'bg-tint-blue-light'
                  : training?.trainingType === 'evaluation'
                  ? 'bg-tint-purple-light'
                  : 'bg-tint-green-light'
              } `}
            >
              <IconTile
                Icon={
                  training?.trainingType === 'training'
                    ? Training
                    : training?.trainingType === 'milestone'
                    ? Flag
                    : training?.trainingType === 'evaluation'
                    ? Evaluation
                    : Training
                }
                color={
                  training?.trainingType === 'training'
                    ? 'green'
                    : training?.trainingType === 'milestone'
                    ? 'blue'
                    : training?.trainingType === 'evaluation'
                    ? 'purple'
                    : 'green'
                }
                size="small_md"
                className="h-12"
              />
            </div>
            <div className="flex flex-wrap">
              <span
                className="pr-2"
                dangerouslySetInnerHTML={{
                  __html: t(
                    'pages.follow_learningpath.settings_training.title',
                    {
                      nameTraning: training?.trainingName,
                      nameLearningpath: learningpath?.lpgroupName,
                    }
                  ),
                }}
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div className="relative flex h-full max-h-[calc(100vh_-_96px)] flex-col border-t border-grey-02">
        <div className="max-h-[calc(100vh_-_173px)] w-full overflow-y-auto pb-3">
          <div className="mx-auto flex w-full  max-w-screen-md flex-col px-3">
            <div className="mt-4 flex flex-row items-center gap-4 rounded-lg border border-grey-02 p-4">
              <div>
                <Switch
                  checked={customSettings}
                  onChange={(isCheck) => {
                    setCustomSettings(isCheck);
                  }}
                />
              </div>
              <div>
                <h4 className="pb-2 font-normal">
                  {t(
                    'pages.follow_learningpath.settings_training.custom_settings'
                  )}
                </h4>
                <p className="text-xs text-grey-05">
                  {t(
                    'pages.follow_learningpath.settings_training.custom_settings_description'
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="mx-auto flex w-full  max-w-screen-md flex-col px-3">
            <div className="mb-1 mt-6 text-sm text-black">
              <Label htmlFor="name">
                {t('pages.follow_learningpath.settings_training.title_name')}
              </Label>
              <InputText
                id="name"
                onChange={(e) => setTrainingName(e.currentTarget.value)}
                value={trainingName}
                className="w-full"
                disabled={!customSettings}
              />
            </div>

            <div className="mb-1 mt-6 text-sm text-black">
              <Label htmlFor="description">
                {t('pages.follow_learningpath.settings_training.description')}
              </Label>
              <InputTextarea
                id="description"
                minRows={2}
                onChange={(e) => setTrainingDescription(e.currentTarget.value)}
                value={trainingDescription}
                disabled={!customSettings}
              />
            </div>
          </div>
          <div className="mx-auto mt-8 flex  w-full max-w-screen-md flex-col px-3">
            {(training?.trainingType === 'training' ||
              training?.trainingType === 'evaluation') && (
              <SettingsTR
                trainingDetail={training}
                setTypeOfTraining={setTypeOfTraining}
                typeOfTraining={typeOfTraining}
                setTrainingContentLinking={setTrainingContentLinking}
                trainingContentLinking={trainingContentLinking}
                setMinScore={setMinScore}
                minScore={minScore}
                customSettings={customSettings}
              />
            )}
            {training?.trainingType === 'milestone' && (
              <SettingsTRM
                trainingDetail={training}
                // handleChangeTraining={handleChangeTraining}
                setTypeOfTraining={setTypeOfTraining}
                typeOfTraining={typeOfTraining}
                setMilestoneChange={setMilestoneChange}
                authUser={authUser}
              />
            )}
          </div>
          {((training?.trainingType === 'training' &&
            (typeOfTraining !== 'online' ||
              trainingContentLinking === 'URL')) ||
            (training?.trainingType === 'evaluation' &&
              typeOfTraining === 'external')) && (
            <div className="mx-auto flex w-full  max-w-screen-md flex-col px-3">
              <h3 className="mt-8 mb-3 text-base">
                {t(
                  'pages.follow_learningpath.settings_training.practical_information'
                )}
              </h3>
              <PracticalInformationTR
                authOrg={authOrg}
                trainingDetail={training}
                typeOfTraining={typeOfTraining}
                setLocation={setLocation}
                location={location}
                setRegistrationLink={setRegistrationLink}
                registrationLink={registrationLink}
                setChangeTraining={setChangeTraining}
              />
            </div>
          )}
        </div>
        <div className="mt-auto flex w-full border-t border-grey-02 py-5">
          <div className="mx-auto flex w-full max-w-screen-md justify-end px-3">
            <Button
              variant="outline"
              onClick={() => {
                document.body.style.overflow = 'unset';
                setSelectTrainig(null);
                setIsOpenSettings(false);
              }}
              className="mr-auto"
            >
              {t('button.cancel')}
            </Button>
            <Button
              className="mr-2"
              onClick={() => {
                handleChangeTraining();
              }}
              // disabled={!customSettings}
            >
              {t('button.done')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
